'use client'

import type { SwitcherSlideInProps } from '@maestro/commerce-blocks/components/switcher/switcher.types'

import { useTranslations } from 'next-intl'

import { SwitcherListSkeleton } from '@maestro/commerce-blocks/components/switcher'
import { Button } from '@pearlconvert/ui/components/button'
import { Fieldset } from '@pearlconvert/ui/components/fieldset'
import { Input } from '@pearlconvert/ui/components/input'
import {
  SlideInBody,
  SlideInFooter,
} from '@pearlconvert/ui/components/slide-in'
import { getSuppressTracking } from '@pearlconvert/ui/utils/suppression.utils'

import '@maestro/commerce-blocks/components/switcher/styles/switcher.scss'

export default function SwitcherSlideIn(props: SwitcherSlideInProps) {
  const { search, isLoading, isEmpty, emptyState, children, onClose } = props
  const t = useTranslations('commerce-blocks')

  return (
    <>
      <SlideInBody>
        <div className="switcher__content">
          {search && (
            <form
              className="switcher__search-form"
              action="."
              onSubmit={(e) => {
                e.preventDefault()
                ;(document.activeElement as HTMLElement)?.blur()
              }}
            >
              <Fieldset legend={search.legend}>
                <Input
                  id="switcher-search"
                  {...getSuppressTracking()}
                  type="search"
                  icon="search"
                  name="text"
                  className="switcher__search-input"
                  placeholder={search.placeholder}
                  onChange={(e) => {
                    search.onChange(e.target.value)
                  }}
                />
              </Fieldset>
            </form>
          )}
          {isLoading ? (
            <SwitcherListSkeleton />
          ) : isEmpty ? (
            emptyState
          ) : (
            children
          )}
        </div>
      </SlideInBody>
      <SlideInFooter>
        <Button size="large" type="primary" onClick={onClose}>
          {t('_globals.go-back')}
        </Button>
      </SlideInFooter>
    </>
  )
}
